var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHomez(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 9,
    viewBox: "0 0 42 9",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.601.5c2.286 0 3.993 1.694 3.993 4s-1.706 4-3.993 4-4.004-1.695-4.004-4c0-2.306 1.718-4 4.004-4zM25.35.5l3.44 2.481V8.5h-1.314V3.676l-2.123-1.532-2.105 1.53V8.5h-1.313V3.676l-2.123-1.532-2.105 1.53V8.5h-1.313V2.983L19.808.5l2.781 2.007L25.349.5zM1.273.9v3.094h3.851V.9h1.273v7.6H5.124V5.07H1.273V8.5H0V.9h1.273zm33.912 0v1.075h-3.96V4.07h3.64v1.032h-3.64v2.323h3.96V8.5h-5.197V.9h5.197zm6.64 0v.674l-4.376 5.945h4.534V8.5h-5.998v-.674l4.377-5.945h-4.22V.9h5.683zM11.6 1.697c-1.56 0-2.71 1.185-2.71 2.803 0 1.618 1.151 2.803 2.711 2.803 1.55 0 2.699-1.185 2.699-2.803 0-1.618-1.15-2.803-2.7-2.803z",
    fill: "currentColor",
    fillRule: "nonzero"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomez);
export default __webpack_public_path__ + "static/media/homez.7c630dbe22e0bcdfce903a63e478ef5f.svg";
export { ForwardRef as ReactComponent };